//Env variables..
export let APP_ENV = process.env.REACT_APP_ENV;
export let GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
export let SDK_APP_KEY = process.env.REACT_APP_SDK_APP_KEY;
export let SDK_APP_URL = process.env.REACT_APP_SDK_APP_URL;
export let API_URL = process.env.REACT_APP_API_URL;
export let BASE_URL = process.env.REACT_APP_BASE_URL;
export let WALLET_URL = process.env.REACT_APP_WALLET_URL;
export let FOUNDATION_URL = process.env.REACT_APP_FOUNDATION_URL;